import { UseMutateFunction } from 'react-query';

import {
  ReservationLocalstorageSteps,
  StepThreeCalculations,
} from 'modules/accommodations/features/reservations/components/ReservationAddNew/ReservationSteps/consts';
import { constructPayloadForAPI } from 'modules/accommodations/features/reservations/helper';
import {
  TApiData,
  TCalculationTableState,
  TDiscountTableData,
  TDiscountTableDataCalculation,
  TServicesTableDataCalculation,
  TServiceTableData,
} from 'modules/accommodations/features/reservations/models';

export const deleteElementAndExecuteAPI = (
  typeOfCalculate: string,
  servicesOrDiscountsTableData: any,
  setThirdStepTableState: (newState: Partial<TCalculationTableState>) => void,
  indexOfElement: number,
  transformedServicesOrDiscountsDataForAPI:
    | TServicesTableDataCalculation[]
    | TDiscountTableDataCalculation[],
  transformedServicesDataForAPI: TServicesTableDataCalculation[],
  transformedDiscountsDataForAPI: TDiscountTableDataCalculation[],
  unitId: string,
  addOrEditServicesMutate: UseMutateFunction<any, unknown, TApiData, unknown>,
  servicesOrdiscountTableData: TServiceTableData[] | TDiscountTableData[],
) => {
  // update state for table
  const deletedElementTableData = [...servicesOrDiscountsTableData];
  deletedElementTableData.splice(indexOfElement, 1);

  if (typeOfCalculate === StepThreeCalculations.SERVICES) {
    setThirdStepTableState({ servicesTableData: deletedElementTableData });
  } else if (typeOfCalculate === StepThreeCalculations.DISCOUNTS) {
    setThirdStepTableState({ discountsTableData: deletedElementTableData });
  }

  //make API call
  const deletedElementForAPIData = [...transformedServicesOrDiscountsDataForAPI];
  deletedElementForAPIData.splice(indexOfElement, 1);

  let servicesDataAPI: any = [];
  let discountsDataAPI: any = [];
  if (typeOfCalculate === StepThreeCalculations.SERVICES) {
    servicesDataAPI = deletedElementForAPIData;
    discountsDataAPI = transformedDiscountsDataForAPI;
  } else if (typeOfCalculate === StepThreeCalculations.DISCOUNTS) {
    servicesDataAPI = transformedServicesDataForAPI;
    discountsDataAPI = deletedElementForAPIData;
  }
  const apiPayload: TApiData = constructPayloadForAPI(unitId, servicesDataAPI, discountsDataAPI);
  addOrEditServicesMutate(apiPayload);

  //save services and discounts to localStorage
  let servicesDataLocalstorage: any = [];
  let discountsDataLocalstorage: any = [];
  if (typeOfCalculate === StepThreeCalculations.SERVICES) {
    servicesDataLocalstorage = deletedElementTableData;
    discountsDataLocalstorage = servicesOrdiscountTableData;
  } else if (typeOfCalculate === StepThreeCalculations.DISCOUNTS) {
    servicesDataLocalstorage = servicesOrdiscountTableData;
    discountsDataLocalstorage = deletedElementTableData;
  }
  const { calculationServices, calculationDiscountServices } = apiPayload;
  const localStorageData = {
    services: servicesDataLocalstorage,
    discountServices: discountsDataLocalstorage,
    servicesStepFour: calculationServices,
    discountServicesStepFour: calculationDiscountServices,
  };
  localStorage.setItem(ReservationLocalstorageSteps.THIRDSTEP, JSON.stringify(localStorageData));
};
